module.exports = __webpack_public_path__ + "static/media/4362.8e4abf97.jpg";